import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "./components/Navigation";
import HeroVideo from "./components/HeroVideo";
import Method from "./components/Method";
import Portfolio from "./components/Portfolio";
import Impressions from "./components/Impressions";
import SkillsProof from "./components/SkillsProof";
import Team from "./components/Team";
import Clients from "./components/Clients";
import Footer from "./components/Footer";
import CallbackModal from "./components/CallbackModal";
import VideoModal from "./components/VideoModal";
import CustomCursor from "./components/CustomCursor";
import Admin from "./pages/Admin";
import ArticlePage from "./pages/ArticlePage";
import PrivacyPage from "./pages/PrivacyPage";
import { useContent } from "./lib/api";

const DEFAULT_SECTION_ORDER = ["studio", "skills", "method", "work", "team", "clients"];

function Landing() {
  const { content } = useContent();
  const { site, projects, team, clients, testimonials } = content;
  const [callbackOpen, setCallbackOpen] = useState(false);
  const [heroVideoOpen, setHeroVideoOpen] = useState(false);

  // Scroll to anchor when navigated with /#section_id from another route
  useEffect(() => {
    if (typeof window === "undefined") return;
    const hash = window.location.hash?.slice(1);
    if (!hash) return;
    const tryScroll = () => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    // wait for content to render
    const id = setTimeout(tryScroll, 350);
    return () => clearTimeout(id);
  }, [site]);

  const order = (site.section_order && site.section_order.length ? site.section_order : DEFAULT_SECTION_ORDER);
  const enabled = site.section_enabled || {};
  const visible = order.filter((id) => enabled[id] !== false);

  const SECTIONS = {
    studio:  <Impressions site={site} />,
    skills:  <SkillsProof site={site} />,
    method:  <Method site={site} />,
    work:    <Portfolio projects={projects} />,
    team:    <Team site={site} members={team} />,
    clients: <Clients site={site} clients={clients} testimonials={testimonials} />,
  };

  return (
    <main className="bbf-grain bg-[#050505] text-white min-h-screen">
      <CustomCursor />
      <Navigation site={site} onDiscussClick={() => setCallbackOpen(true)} />
      <HeroVideo site={site} onTitleClick={() => setHeroVideoOpen(true)} />

      {visible.map((id) => (
        <React.Fragment key={id}>{SECTIONS[id]}</React.Fragment>
      ))}

      <Footer site={site} />

      {callbackOpen && <CallbackModal onClose={() => setCallbackOpen(false)} />}
      {heroVideoOpen && (
        <VideoModal
          url={site.showreel_url}
          title={site.hero_headline?.replace(/\n/g, " ")}
          subtitle="Big Bag Films · Шоурил"
          onClose={() => setHeroVideoOpen(false)}
        />
      )}
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0e0e0e",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "white",
            fontFamily: "Manrope, sans-serif",
            borderRadius: 0,
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/article/:slug" element={<ArticlePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </BrowserRouter>
  );
}
